import { useEffect } from 'react';

/**
 * usePrintFileName hook.
 * "Save as PDF" names the file after the page title: while printing (the download button, Ctrl+P, the batch print)
 * the title is the report file name (`reportFileName`), after printing the previous title is back.
 *
 * @category hooks.
 */
const usePrintFileName = (fileName?: string): void => {
  useEffect(() => {
    if (!fileName) return;

    let title = document.title;
    const set = () => {
      title = document.title;
      document.title = fileName;
    };
    const restore = () => {
      document.title = title;
    };

    window.addEventListener('beforeprint', set);
    window.addEventListener('afterprint', restore);

    return () => {
      window.removeEventListener('beforeprint', set);
      window.removeEventListener('afterprint', restore);
    };
  }, [fileName]);
};

export { usePrintFileName };
